export default __webpack_public_path__ + "static/media/flag-de.38058217.svg";